import * as React from 'react';
import { useAppSelector } from 'hooks';
import { ControlledSelect } from 'components';
import { selectActiveMediaAgencies } from 'store/consts';
import { useFormContext, useController } from 'react-hook-form';
import { selectAllClients } from 'store/clients';
import { useTranslation } from 'react-i18next';

const CampaignMediaAgency = ({
  isDisabled = false,
  ...props
}: {
  isDisabled?: boolean;
  [key: string]: any;
}): JSX.Element => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();
  const {
    field: { value: clientValue },
  } = useController({
    name: 'client',
    control,
  });

  const {
    field: { value: agencyValue },
  } = useController({
    name: 'mediaAgency',
    control,
  });
  const clients = useAppSelector(selectAllClients);
  const mediaAgency = useAppSelector(selectActiveMediaAgencies);
  const options = React.useMemo(() => {
    return mediaAgency
      ?.map(({ id, name }: { id: string | number; name: string }) => ({
        id,
        name,
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [mediaAgency]);

  React.useEffect(() => {
    if (agencyValue === null && clientValue !== null) {
      const agency = clients.find(client => client.id === clientValue);
      setValue('mediaAgency', agency?.mediaAgency);
    }
  }, [clientValue]);

  return (
    <ControlledSelect
      name='mediaAgency'
      label={t('campaign.mediaAgency', 'Agencja')}
      options={options}
      isDisabled={isDisabled}
      {...props}
    />
  );
};

CampaignMediaAgency.displayName = 'Campaign.mediaAgency';

export { CampaignMediaAgency };
